/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CMSTabParagraphContainer, FeaturesConfigModule, I18nModule } from '@spartacus/core';
import { CommonModule } from '@angular/common';
import {
  PageComponentModule,
  OutletModule,
  TabModule,
  TabParagraphContainerComponent,
  BREAKPOINT,
} from '@spartacus/storefront';
import { combineLatest, distinctUntilChanged, map, Observable, switchMap, tap } from 'rxjs';

const defaultTabConfig = {
  openTabs: [0],
  breakpoint: BREAKPOINT.md,
};

@Component({
  selector: 'cx-tab-paragraph-container',
  templateUrl: './tab-paragraph-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    PageComponentModule,
    OutletModule,
    I18nModule,
    TabModule,
    FeaturesConfigModule,
  ],
})
export class CustomTabParagraphContainerComponent extends TabParagraphContainerComponent {
  override components$: Observable<any[]> = this.componentData.data$.pipe(
    distinctUntilChanged((x, y) => x?.components === y?.components),
    tap((data: CMSTabParagraphContainer) => {
      this.ariaLabel = `${data?.uid}.tabPanelContainerRegion`;
    }),
    switchMap((data) =>
      combineLatest(
        (data?.components ?? '').split(' ').map((component) =>
          this.cmsService.getComponentData<any>(component).pipe(
            distinctUntilChanged(),
            map((tab) => {
              if (!tab) {
                // fix for deliveryTab not being correct implemented
                return undefined;
              }
              if (!tab.flexType) {
                // eslint-disable-next-line no-param-reassign
                tab = {
                  ...tab,
                  flexType: tab.typeCode,
                };
              }
              return {
                ...tab,
                title: `${data.uid}.tabs.${tab.uid}`,
              };
            }),
          ),
        ),
      ).pipe(
        map((tabs) => tabs.filter((tab) => tab !== undefined)),
        // Update tablist label with name from CMS
        tap(() => {
          this.tabConfig$.next({
            label: `${data?.uid}.tabPanelContainerRegionGroup`,
            ...defaultTabConfig,
          });
        }),
      ),
    ),
  );
}
